import './AddMilestone.css';
import React, {useState} from "react";

function AddMilestone(props) {

    const [milestoneText, setMilestoneText] = useState("");

    const handleNoteChange = (event) => {
        setMilestoneText(event.target.value);
      };

    function addMilestone() {
        let milestoneCopy = [...props.milestones]
        milestoneCopy.push(milestoneText)
        props.setMilestones(milestoneCopy)
        setMilestoneText("")
    }

    return (
        <div className="addMilestoneDiv">
            <p className="addMilestoneTextHeader">add a milestone</p>
            <textarea
                    className="milestoneText"
                    type="text"
                    id="milestoneText"
                    value={milestoneText}
                    onChange={handleNoteChange}
                    name="milestoneText"
                    spellCheck="false"
                />
            <p onClick={()=> addMilestone()} className="addMilestoneButton"> add milestone</p>
        </div>
    )
}

export default AddMilestone;